import { FeatureLink as Link } from "@softmax/web-features/navigation";
import { CommunityMarkdown } from "@softmax/web-ux/prose";
import type { ComponentPropsWithoutRef } from "react";

export function renderLink(
  props: ComponentPropsWithoutRef<"a"> & { href: string },
) {
  return <Link {...props} />;
}
export function renderMarkdown({
  body,
  headingSlugs,
}: {
  body: string;
  headingSlugs?: boolean;
}) {
  return (
    <CommunityMarkdown
      body={body}
      headingSlugs={headingSlugs}
      renderLink={renderLink}
    />
  );
}
